// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"a2402db5","506":"8669fe82","650":"fcc3373c","886":"b905db92"}[chunkId] + ".chunk.css";
};